// import DsfIcon from "./icon.js";
// import DsfTextProxy from "./textProxy.js";
// import textContentEditable from "./textContentEditable.vue";
// import DsfRepeatProxy from "./repeatProxy.js";
// import DsfUserInfoWaterMark from "./userInfoWaterMark.vue";
// import DsfFieldLabel from "./fieldCaption";
// import DsfEmptyData from "./emptyData.vue";
// import DsfSlotRenderProxy from "./slotRenderProxy";
// import DsfDivEditor from "./divEditor";

function install(Vue) {
  Vue.component(
    "DsfIcon",
    Vue.defineLazyComponent(() => require("./icon.js"))
  );

  Vue.component(
    "DsfTextProxy",
    Vue.defineLazyComponent(() => require("./textProxy.js"))
  );
  Vue.component(
    "DsfTextContentEditable",
    Vue.defineLazyComponent(() => require("./textContentEditable.js"))
  );
  Vue.component(
    "DsfRepeatProxy",
    Vue.defineLazyComponent(() => require("./repeatProxy.js"))
  );
  Vue.component(
    "DsfUserInfoWaterMark",
    Vue.defineLazyComponent(() => require("./userInfoWaterMark.vue"))
  );
  Vue.component(
    "DsfFieldLabel",
    Vue.defineLazyComponent(() => require("./fieldCaption"))
  );
  Vue.component(
    "DsfEmptyData",
    Vue.defineLazyComponent(() => require("./emptyData"))
  );
  Vue.component(
    "DsfSlotRenderProxy",
    Vue.defineLazyComponent(() => require("./slotRenderProxy"))
  );
  Vue.component(
    "DsfDivEditor",
    Vue.defineLazyComponent(() => require("./divEditor"))
  );
  Vue.component(
    "DsfToDesigner",
    Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_output_common" */ "./toDesigner.vue"))
  );
  Vue.component(
    "SendFlowDialog",
    Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_output_common" */ "./sendFlowDialog.vue"))
  );
  Vue.component(
    "CodeSetDialog",
    Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_output_common" */ "./codeset.vue"))
  );
  Vue.component(
    "ImportTemplateDownload",
    Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_output_common" */ "./importTemplateDownload.vue"))
  );
  Vue.component(
    "ImportTemplateDownload",
    Vue.defineAsyncComponent(() => import(/* webpackChunkName: "output_common" */ "./importTemplateDownload.vue"))
  );
}

export { install };

export default {
  install
};
